import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { LocalRole, Staff, State } from './types';
import { STAFF_COLUMNS } from './utils';

export const getInitialState = () => ({
  staff: [] as Staff[],
  isLoading: false,
  availableRoles: [],
  staffColumns: STAFF_COLUMNS,
  selectedStaff: {} as Record<number, Staff>,
  areAllStaffSelected: false,
  totalStaffCount: 0,
  isStaffEmailConfigLoading: false,
  staffInviteEmailConfig: null,
  excludedStaff: {} as Record<number, Staff>,
  systemStaffRoles: [] as LocalRole[]
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
